import type { GetServerSideProps } from 'next';
import { getLocaleFromRequest, persistSetlangCookie } from '@utils/server-locale';
import { getFlattenedPath } from '@utils/common';
import { fetchDocumentPageProps } from '@utils/fetchDocumentPageProps';
import { withUserGating } from '@guards/UserGating';
import { DocumentPageView } from '@layout/DocumentPageView';

export default withUserGating(DocumentPageView);

export const getServerSideProps: GetServerSideProps = async ({ req, res, query }) => {
  if (query.setlang) {
    // Persist the locale from ?setlang= as an EPIC_LOCALE cookie.
    // This is a workaround for a Next.js 13 edge case: requests to the root basePath URL
    // (/docs?setlang=...) are intercepted by the framework before middleware runs,
    // so the cookie must be set here instead.
    persistSetlangCookie(req, res);

    // Redirect to the same URL without ?setlang= so the param is not visible to the user.
    // Other query params (e.g. ?lang=) are preserved.
    const { setlang: _, ...remainingQuery } = query;
    const queryString = new URLSearchParams(remainingQuery as Record<string, string>).toString();
    return { redirect: { destination: queryString ? `/?${queryString}` : '/', permanent: false } };
  }

  const targetLocale = getLocaleFromRequest(req);
  const flattenedPath = getFlattenedPath('index', targetLocale);

  return fetchDocumentPageProps(flattenedPath, targetLocale);
};
